"use client";

import Icon from "@/components/icon";
import styled from "styled-components";

interface IPros {
  disabled: boolean;
}

export const BoxSelect = styled.div<IPros>`
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  position: relative;
  height: 40px;
  width: 100%;
  background-color: ${({ disabled }) => (disabled ? "var(--blackFooter)" : "")};
  /* Use a lighter gray when disabled to match inputs */
  background-color: ${({ disabled }) => (disabled ? "var(--lightGray)" : "")};
`;

export const SelectComponent = styled.select`
  height: 40px;
  width: 100%;
  box-shadow: none;
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  font-weight: normal;
  font-family: "Outfit", sans-serif;
  color: var(--colorTitle);
  border-radius: 7px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  top: 50%;
  margin-top: -3.5px;
  right: 12px;
  z-index: 0;

  svg {
    fill: var(--colorTitle);
    path {
      fill: transparent;
      stroke: var(--colorTitle);
    }
  }
`;

export const OptionSelect = styled.option`
  color: var(--colorTitle);
  background-color: var(--backgroundColorCard);
  text-transform: capitalize;
`;
